module.exports = __webpack_public_path__ + "static/media/circle-youtube.243796f3.svg";